<script>
  import Vue from 'vue'
  import Component from 'vue-class-component'
  import { Watch } from 'vue-property-decorator'

  import pickby from "lodash.pickby"
  import startswith from "lodash.startswith"

  import * as d3 from "d3";

  @Component({
    props: {
      teachers: Array
    }
  })
  export default class Distribution extends Vue {

    showChart = false

    @Watch('teachers')
    onTeachersChange(newVal, oldVal) {
      if (this.hasComponents(this.teachers)) {
        if (!this.showChart) this.showChart = !this.showChart
        this.renderChart()
      } else {
        this.showChart = false
      }
    }

    mounted() {

      if (this.hasComponents(this.teachers)) {
        this.showViz()
        this.renderChart()
      }

    }
    hasComponents(arr) {
      let hasComponents = false

      for (let i=0; i < arr.length; i++) {
         let obj = pickby(arr[i], function(value, key) {
             return startswith(key, "Avg");
          })
          if (Object.values(obj).filter(value => value).length > 0) {
            hasComponents = true
          }
      }
      return hasComponents
    }
    showViz() {
      this.showChart = true
    }

    setPercentages(counts) {

      const sum = (a, b) => a + b

      const total = Object.values(counts).reduce(sum)

      for (let prop in counts) {
        counts[prop] = Math.ceil((counts[prop] / total) * 100)
      }

      for (let prop in counts) {
        if (isNaN(counts[prop])) {
          counts[prop] = 0
        }
      }
      return counts
    }
    generateChartData(components, ratings, teachers) {

      const _components = [...components]
      const _teachers = [...teachers]

      let chartData = []

      for (let i=0; i < _components.length; i++) {
        chartData.push({component: _components[i], counts: {}})
        for (let j=0; j < ratings.length; j++) {
          chartData[i].counts[ratings[j]] = 0
        }
      }

      for (let i=0; i < _teachers.length; i++) {
        for (let j=0; j < _teachers[i].averages.length; j++) {
          if (_teachers[i].averages[j].hedi) {
            chartData[j].counts[_teachers[i].averages[j].hedi] = chartData[j].counts[_teachers[i].averages[j].hedi] + 1
          }
        }
      }
      return chartData
    }
    generateAverages(arr) {
       return arr.map((component) => {
        component.counts = this.setPercentages(component.counts)
        return {
          'component': component.component,
          'developing': component.counts['developing'],
          'effective': component.counts['effective'],
          'highly-effective': component.counts['highly-effective'],
          'ineffective': component.counts['ineffective']
        }
      })
    }
    renderChart() {

      let svg = d3.select(".component-distribution")

      const margin = {top: 20, right: 20, bottom: 30, left: 80}
      const width = +svg.attr("width") - margin.left - margin.right
      const height = +svg.attr("height") - margin.top - margin.bottom

      let g = svg.append("g").attr("transform", `translate(${margin.left},${margin.top})`);

      const x = d3.scaleBand()
                .rangeRound([0, width])
                .paddingInner(0.3)
                .paddingOuter(1)
                .align(0.1);

      const y = d3.scaleLinear()
                .rangeRound([height, 0])

      const z = d3.scaleOrdinal()
            .range(["#f8ee6e", "#ffc76b", "#bae58a", "#78a8e1"]);

      const components = ['1a', '1e', '2a', '2d', '3b', '3c', '3d', '4e']

      const ratings = ['ineffective', 'developing', 'effective', 'highly-effective']

      x.domain(components.map(function(d) { return d; }));

      y.domain([0, 100]).nice(3)

      z.domain(ratings)

      const chartData = this.generateChartData(components, ratings, this.teachers)

      const averages = this.generateAverages(chartData)

      const stack = d3.stack().keys(ratings)(averages)

      g.append("g")
        .selectAll("g")
        .data(stack)
        .enter().append("g")
        .attr("fill", function(d) { return z(d.key); })
        .selectAll("rect")
        .data(function(d) { return d; })
        .enter().append("rect")
        .attr("x", function(d) { return x(d.data.component); })
        .attr("y", function(d) { return y(d[1]); })
        .attr("height", function(d) { return y(d[0]) - y(d[1]); })
        .attr("width", x.bandwidth());

      g.append("g")
      .attr("class", "x-axis")
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x).tickPadding(10).tickSize(0))

      g.append("g")
      .attr("class", "y-axis")
      .call(d3.axisLeft(y).ticks(3).tickPadding(10).tickSize(0).tickFormat((d => d + "%")));
    }
  }
</script>

<template>
  <div>
    <svg v-show="showChart" class="component-distribution" width="745" height="400"></svg>
    <div v-show="!showChart"><p>No results</p></div>
  </div>
</template>

<style lang="scss" scoped>
  svg {
    opacity: 0.54;
  }
</style>